/**
 * Create a  function that is called after amout of time delay,
 *
 * @param func - the function to call
 * @param wait - the number of milliseconds delay for function call
 * @param immediate - if true then no delay for function call
 * @returns a new function that is debounce
 */
export default (func, wait, immediate) => {
  let timeout;
  return function _(...args) {
    const context = this;
    /** timeout */
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};
